import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Materials, PaginatedMaterialsList } from "../../app/generated-axios-client";

export interface MaterialsState {
  list: PaginatedMaterialsList;
  material: Materials | null;
}

const initialState: MaterialsState = {
  list: {
    pagination: {
      total_items: 0,
      total_pages: 0,
      current_page: 0,
      per_page: 0,
    },
    results: [],
  },
  material: null,
};

export const materialsSlice = createSlice({
  name: "materials",
  initialState,
  reducers: {
    addMaterialList: (state, action: PayloadAction<PaginatedMaterialsList>) => {
      state.list = action.payload;
    },
    storeMaterial: (state, action: PayloadAction<Materials>) => {
      state.material = action.payload;
    },
    removeMaterial: (state) => {
      state.material = null;
    },
    addOrUpdateMaterial: (_state, _action: PayloadAction<Materials>) => {},
    deleteMaterial: (_state, _action: PayloadAction<string>) => {},
  },
});

export const materialsActions = materialsSlice.actions;
export const materialsReducer = materialsSlice.reducer;
export default materialsReducer;
